
import { computed, defineComponent } from "vue";
import RecordComment from "@/components/tab/RecordComment.vue";
import EngineAnalytics from "@/components/tab/EngineAnalytics.vue";
import EvaluationChart from "@/components/tab/EvaluationChart.vue";
import RecordInfo from "@/components/tab/RecordInfo.vue";
import { Action, useStore } from "@/store";
import { RectSize } from "@/components/primitive/Types";
import ButtonIcon from "@/components/primitive/ButtonIcon.vue";

export const headerHeight = 30;

export const minHeight = 240 + headerHeight;

export default defineComponent({
  name: "TabPane",
  components: {
    RecordComment,
    EngineAnalytics,
    EvaluationChart,
    RecordInfo,
    ButtonIcon,
  },
  props: {
    size: {
      type: RectSize,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const changeSelect = (id: string) => {
      store.dispatch(Action.UPDATE_APP_SETTING, {
        tab: id,
      });
    };
    const activeTab = computed(() => store.state.appSetting.tab);
    const contentSize = computed(() =>
      props.size.reduce(new RectSize(0, headerHeight))
    );
    return {
      activeTab,
      contentSize,
      headerHeight,
      changeSelect,
    };
  },
});
